import type { OldSitemapSite } from '../entities/site';

import { TopView } from './top-view';

export type SiteViewProps = {
  site: OldSitemapSite;
};

function pos(index: number): [number, number] {
  const MAX_ROWS = 6;
  const MAX_COLS = 3;

  const highestIndex = MAX_ROWS * MAX_COLS - 1;

  if (index > highestIndex) {
    const offset = index - highestIndex;
    return [MAX_COLS, MAX_ROWS + offset];
  }

  const x = Math.floor(index / MAX_ROWS);
  const y = index % MAX_ROWS;

  return [x + 1, y + 1];
}

export function SiteView({ site }: SiteViewProps) {
  return (
    <div className="w-full max-w-2xl space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">{site.id}</h2>
      <div className="grid grid-flow-col grid-cols-3 gap-2 gap-y-4">
        {site.tops.map(function (top, index) {
          const [x, y] = pos(index);

          return (
            <TopView
              key={top.id}
              top={top}
              style={{
                gridColumn: x,
                gridRow: y,
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
